module.exports = __webpack_public_path__ + "static/media/deleteIcon.d38aa85f.svg";